import * as React from "react";
import { useTranslation } from "react-i18next";
import { DocumentTitle, Spinner } from "components/common";
import getDisplayName from "authentication/helpers/getDisplayName";
import { AUTH_SERVICE_TYPE } from "authentication/components/saml/constants";
import { fromAuthenticationBackend } from "authentication/components/saml/config/helpers/samlConfigConverter";
import useSAMLTeamSyncConfig from "authentication/components/saml/hooks/useSAMLTeamSyncConfig";
import SAMLBackendConfigSection from "./SAMLBackendConfigSection";
import SAMLTeamSyncConfigSection from "./SAMLTeamSyncConfigSection";
const SAMLBackendConfigDetails = ({ authenticationBackend }) => {
  const { t } = useTranslation("enterprise_authentication");
  const { isLoading, teamSyncBackend } = useSAMLTeamSyncConfig(authenticationBackend.id);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const displayName = getDisplayName(AUTH_SERVICE_TYPE);
  const backend = fromAuthenticationBackend(authenticationBackend, teamSyncBackend);
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("saml.saml_backend_config_details.title", { displayName }) }, /* @__PURE__ */ React.createElement(SAMLBackendConfigSection, { authenticationBackend: backend }), /* @__PURE__ */ React.createElement(SAMLTeamSyncConfigSection, { authenticationBackend: backend }));
};
export default SAMLBackendConfigDetails;
